export const removeNullCharacter = (str) => {
  if (!str) {
    return '';
  }
  return str.replace(/\0/g, '');
};
